import { useQueryClient } from "@tanstack/react-query";
import { useMutation } from "@tanstack/react-query";
import type { UseMutationResult } from "@tanstack/react-query";

import { deleteTodo } from "@/tasks/services";
import { queryKeysTasks } from "@/tasks/config";
import type { Todo } from "@/tasks/types";

interface DeleteTodoContext {
  previousTodos?: Todo[];
  deletedId: number;
}

const useDeleteTodo = (): UseMutationResult<void, Error, number> => {
  const queryClient = useQueryClient();

  return useMutation<void, Error, number>({
    mutationFn: (id: number) => deleteTodo(id),
    onMutate: async (deletedId: number) => {
      await queryClient.cancelQueries({ queryKey: queryKeysTasks.lists() });

      const previousTodos = queryClient.getQueryData<Todo[]>(
        queryKeysTasks.list({}),
      );

      queryClient.setQueriesData<Todo[]>(
        { queryKey: queryKeysTasks.lists() },
        (old) => old?.filter((todo) => todo.id !== deletedId) || [],
      );

      return { previousTodos, deletedId };
    },

    onError: (error, _, context) => {
      const typedContext = context as DeleteTodoContext | undefined;
      if (typedContext?.previousTodos) {
        queryClient.setQueryData(
          queryKeysTasks.list({}),
          typedContext.previousTodos,
        );
      }

      console.error("Erro ao deletar todo:", error);
    },

    onSuccess: (_, deletedId) => {
      queryClient.removeQueries({ queryKey: queryKeysTasks.detail(deletedId) });

      queryClient.invalidateQueries({ queryKey: queryKeysTasks.lists() });
    },
  });
};

export { useDeleteTodo };
